/* eslint-disable react/react-in-jsx-scope */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Typography } from '@maas-components/core'
import IconButton from '@material-ui/core/IconButton'
import useMediaQuery from '@material-ui/core/useMediaQuery'
import clsx from 'clsx'
import { IToolBar } from '../SideBar/types'
import useStyles from './style'

const ToolBar = ({ title, icon, options, setOptions }: IToolBar) => {
  const isDownMD = useMediaQuery((muiTheme: any) => muiTheme.breakpoints.down(1324))
  const { isOpen } = options

  const classes = useStyles()

  const handleToggleNavigation = () => {
    setOptions({
      ...options,
      isOpen: !isOpen,
      isOpenFromMenu: true,
    })
  }

  const cssBar = clsx(classes.root, {
    [classes.rootOpen]: isOpen,
    [classes.rootClose]: !isOpen,
  })

  const cssIcon = clsx(classes.icon, {
    [classes.iconOpen]: isOpen,
    [classes.iconClosed]: !isOpen,
  })

  return (
    <div className={cssBar}>
      <IconButton
        disableFocusRipple
        disableRipple
        onClick={handleToggleNavigation}
        className={cssIcon}
      >
        {icon}
      </IconButton>
      {isDownMD ? <Typography>{title}</Typography> : null}
    </div>
  )
}

export default ToolBar
